"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

interface GemsFiltersProps {
  searchQuery: string;
  questType: string;
  onSearchChange: (value: string) => void;
  onQuestTypeChange: (value: string) => void;
}

const GAME_QUEST_CATEGORY = "in_game";
const ALL_QUEST_CATEGORY = "all";

export function GemsFilters({
  searchQuery,
  questType,
  onSearchChange,
  onQuestTypeChange,
}: GemsFiltersProps) {
  const isInGameOnly = questType === GAME_QUEST_CATEGORY;

  return (
    <div className="space-y-2">
      <Input
        placeholder="Search quests..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="h-8 text-xs bg-white/5 border-white/20 text-white placeholder:text-white/40 focus:border-white/40"
      />

      <div className="flex items-center gap-2">
        <Checkbox
          id="in-game-only"
          checked={isInGameOnly}
          onCheckedChange={(checked) =>
            onQuestTypeChange(
              checked ? GAME_QUEST_CATEGORY : ALL_QUEST_CATEGORY,
            )
          }
          className="border-white/50"
        />
        <label
          htmlFor="in-game-only"
          className="text-xs text-white/50 hover:text-white cursor-pointer select-none"
        >
          Reward eligible quests only
        </label>
      </div>
    </div>
  );
}
